export const listeDesProjets = [



  {
    id: 'Projet N°22',
    title: 'Event Ease',
    picture: 'https://res.cloudinary.com/dtqlngqss/image/upload/v1697699471/eventease2023.png',
    describe:'Développement d\'une application pour faciliter la gestion du planning en ligne des bénévoles et optimiser leur travail au quotidien.',
    lien: ' https://github.com/melaniemdm/eventEase',
  },
 
  {
    id: 'Projet N°21',
    title: 'AdaptiveResume',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1674746476/mdm-devlopment/adaptativeResume_mo8mkv.png',
    describe:'Création d\'une landing page pour le lancement de la version bêta d\'une application demandé par la société Adaptive resume.',
    lien: ' https://github.com/melaniemdm/adaptiveresume',
  },
  {
    id: 'Projet N°20',
    title: 'SportSee',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1674490512/mdm-devlopment/sportsee_m2s3ov.png',
    describe:'Création d\'une page qui va permettre à l\'utilisateur de suivre le nombre de sessions réalisées ainsi que le nombre de calories brûlées.',
    lien: ' https://github.com/melaniemdm/sportSee',
  },
  {
    id: 'Projet N°19',
    title: 'Fondation Jacques Secrétin',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847191/mdm-devlopment/fondJS2_zqvhty.png',
    describe:'Prototype de site internet pour la Fondation Jacques Secrétin. ',
    lien: ' https://melaniemdm.github.io/fondation-jacques-secretin/',
  },
  {
    id: 'Projet N°18',
    title: ' Intelligence Canine',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847191/mdm-devlopment/intCanine2_xnp1v2.png',
    describe:'Conception et réalisation d\'un site complet en javaScript React pour la société Intelligence Canine.',
    lien: 'https://melaniemdm.github.io/intelligence_canine/',
  },
  {
    id: 'Projet N°17',
    title: ' MDM DEVELOPMENT',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847189/mdm-devlopment/mdm2_a3mzgx.png',
    describe:'Réalisation d\'un site complet en javaScript React.',
    lien: 'https://melaniemdm.github.io/mdm_development/',
  },
  {
    id: 'Projet N°16',
    title: ' LCT CREATIONS',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847191/mdm-devlopment/lct2_ywrusw.png',
    describe:'Prototype de site avec diverses animations (carouselle, affichage au schroll...)',
    lien: 'https://melaniemdm.github.io/lct-creations/',
  },
  {
    id: 'Projet N°15',
    title: ' Association Saint Maurienne des Amis des animaux',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847190/mdm-devlopment/asmaa2_wwiomx.png',
    describe:'Création de fiches pour l\'adoption des chats d\'un refuge',
    lien: 'https://melaniemdm.github.io/adopt-un-chat/',
  },
  {
    id: 'Projet N°14',
    title: 'Kasa',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847191/mdm-devlopment/kasa2_zl1cyk.png',
    describe:[
      ' Création d\'un site de reservation de logement', <br key="1" />,
      'Utilisation de React'], 
    lien: 'https://melaniemdm.github.io/kasa-oc/',
  },
  {
    id: 'Projet N°13',
    title: 'Learn@Home',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847189/mdm-devlopment/learn2_dyz0kd.png',
    describe:[
      ' Création d\'une maquette pour un site de soutien scolaire', <br key="1" />,
      'Utilisation de Notion et de Figma '], 
    lien: 'https://www.figma.com/file/aB2H1x8555crFs2qOJUHSS/Learn%40Home',
  },
  {
    id: 'Projet N°12',
    title: 'Billed',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847190/mdm-devlopment/billed2_viceii.png',
    describe:' Ajout de tests unitaires et d\'integration', 
    lien: ' ',
  },
  {
    id: 'Projet N°11',
    title: 'vendTout',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847190/mdm-devlopment/vendtout2_nxatpb.png',
    describe:'Maquette d\'un site de vente en ligne ', 
    lien: 'https://melaniemdm.github.io/vendTout/',
  },
  {
    id: 'Projet N°10',
    title: 'testOn',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847190/mdm-devlopment/testOn2_bv0enm.png',
    describe:[
      '   Maquette d\'un site de vente avec modal et prix évolutif  ', <br key="1" />,
      'Respect du cahier des charges et de la maquette.'], 
    lien: 'https://melaniemdm.github.io/testOn/',
  },
  {
    id: 'Projet N°9',
    title: 'jsMarketing',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847191/mdm-devlopment/jsMarketing2_bgic7x.png',
    describe:[
      '  Amélioration d\'un site marketing pour un auto-entrepreneur ', <br key="1" />,
      'Respect du cahier des charges et adaptation d\'un thème WordPress aux spécificités souhaitées par le client.',<br key="2" />,
      'Ajout d\'un css personnalisé '], 
    lien: 'https://psm94.wordpress.com/',
  },
  {
    id: 'Projet N°8',
    title: 'PSM94',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847190/mdm-devlopment/psm942_cciiiv.png',
    describe:[
      ' Prototype d\'un site de psychologie à Saint-Maur', <br key="1" />,
      'Utilisation des fonctionnalités gratuites Wordpress 5 pour la conception du prototype du site d\'un professionnel de santé '], 
    lien: 'https://psm94.wordpress.com/',
  },
  {
    id: 'Projet N°7',
    title: 'Les petits Plats',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847190/mdm-devlopment/petitsPLats2_xsu7fy.png',
    describe:
      'Implémentation de fonctionnalités de recherche pour un site de recettes de cuisine',
    lien: 'https://melaniemdm.github.io/les_Petits_Plats/',
  },
  {
    id: 'Projet N°6',
    title: 'animalsLove',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847280/mdm-devlopment/animalsLove2_cplye1.png',
    describe:[
      'Construction d\'un prototype d\'un nouveau site web dédié a l\'adoption d\'animaux', <br key="1" />,
      'Création de diverses affiches pour des evenements '], 
    lien: 'https://melaniemdm.github.io/animals-love/',
  },
  {
    id: 'Projet N°5',
    title: 'Cab&Co',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847190/mdm-devlopment/cab2_yeyhjl.png',
    describe:
      'Construction d\'un prototype  d\'un nouveau site web pour des experts comptables. ',
    lien: 'https://melaniemdm.github.io/Cab_And_co/',
  },
  {
    id: 'Projet N°4',
    title: 'fishEye',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847190/mdm-devlopment/fisheye2_dezfne.png',
    describe:
      'Construction d\'un prototype fonctionnel d\'un nouveau site web pour les photographes.',
    lien: 'https://melaniemdm.github.io/fisheye/',
  },
  
  {
    id: 'Projet N°3',
    title: 'GameOn',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847191/mdm-devlopment/gameOn2_kaoe5h.png',
    describe:
      'Ajoute de code JavaScript manquant pour que le formulaire du site soit pleinement fonctionnel',
    lien: 'https://melaniemdm.github.io/GameOn-website-FR/starterOnly/',
  },
  {
    id: 'Projet N°2',
    title: 'OhMyFood',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658847189/mdm-devlopment/omf2_wmx8lz.png',
    describe:
      'Site pour mobile qui repertorie les menus de plusieurs retaurants gastronomiques',
    lien: 'https://melaniemdm.github.io/Projet_3_ohmyfood/',
  },
  {
    id: 'Projet N°1',
    title: 'Reservia',
    picture: 'https://res.cloudinary.com/dst61tkcz/image/upload/v1658846527/mdm-devlopment/reservia2_ffykof.png',
    describe: 'Site de reservation d\'hôtels',
    lien: '/Projet_2_Reservia/Reservia.html',
  },
  
  
 
  

];
